import React, { useState } from "react";
import styled from "styled-components";
import AccountServices from "../based/services/AccountServices";
import { CONSTANTS, NOTIFY, SOCIAL } from "../based/Constants";
import { Notify } from "../based/Notify";
import Logo from "./components/Image/LogoArtist.svg";

const GetRedirect = (redirect) => {
    let findText = "?redirect=";
    let indexOf = redirect.indexOf(findText);
    if (indexOf >= 0) {
        let splitString = redirect.substring(indexOf + findText.length, redirect.length + 1);
        return splitString;
    } else {
        return redirect;
    }
};

function LoginArtist(props) {
    const [isLoading, setIsLoading] = useState(false);

    async function _handleRenderDialog(social) {
        let redirect = props.location.search;
        setIsLoading(true);
        const [err, data] = await AccountServices.OAuthDialogSocial(social);
        if (!err && data) {
            let href = GetRedirect(redirect) || "/";
            localStorage.setItem(CONSTANTS.LOGIN_URL_CALLBACK, href);
            window.location.href = data;
            setIsLoading(false);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Đăng nhập thất bại");
            setIsLoading(false);
        }
    }

    return (
        <LoginArtistStyle>
            <div className="logo-verify">
                <img src={Logo} alt="logo" />
            </div>
            <div className="login-artist">
                <div className="title">Đăng nhập bằng</div>
                <div
                    className="logo"
                    onClick={() => {
                        _handleRenderDialog(SOCIAL.Tiktok);
                    }}
                >
                    <svg width="175" height="46" viewBox="0 0 175 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="175" height="46" rx="23" fill="black" />
                        <path
                            d="M53.9859 17.5504C56.052 19.0266 58.5831 19.8952 61.3169 19.8952V14.6373C60.7995 14.6375 60.2835 14.5835 59.7773 14.4763V18.615C57.0438 18.615 54.513 17.7465 52.4463 16.2704V27.0001C52.4463 32.3677 48.0928 36.7186 42.7228 36.7186C40.7192 36.7186 38.8568 36.1132 37.3098 35.0748C39.0755 36.8793 41.5379 37.9987 44.2621 37.9987C49.6324 37.9987 53.9861 33.6477 53.9861 28.2799V17.5504H53.9859ZM55.8851 12.2459C54.8292 11.0929 54.1359 9.60287 53.9859 7.95557V7.2793H52.5269C52.8941 9.37301 54.1468 11.1618 55.8851 12.2459ZM40.7063 30.9559C40.1164 30.1828 39.7976 29.237 39.799 28.2646C39.799 25.8097 41.7902 23.8192 44.2469 23.8192C44.7048 23.8191 45.1599 23.8891 45.5962 24.0275V18.6521C45.0863 18.5823 44.5717 18.5526 44.0573 18.5635V22.7474C43.6206 22.6091 43.1653 22.5388 42.7074 22.5392C40.2507 22.5392 38.2595 24.5295 38.2595 26.9847C38.2595 28.7208 39.2548 30.2238 40.7063 30.9559Z"
                            fill="#FF004F"
                        />
                        <path
                            d="M52.4481 16.2703C54.5148 17.7463 57.0456 18.6149 59.7791 18.6149V14.4762C58.2533 14.1514 56.9025 13.3544 55.8869 12.2459C54.1484 11.1617 52.8959 9.3729 52.5287 7.2793H48.6964V28.2797C48.6877 30.7279 46.6999 32.7103 44.2485 32.7103C42.8039 32.7103 41.5205 32.0221 40.7078 30.9559C39.2564 30.2238 38.2611 28.7207 38.2611 26.9848C38.2611 24.5298 40.2522 22.5393 42.7089 22.5393C43.1796 22.5393 43.6333 22.6126 44.0588 22.7475V18.5636C38.7832 18.6726 34.5403 22.981 34.5403 28.2798C34.5403 30.925 35.5969 33.3229 37.3117 35.0749C38.8587 36.1132 40.7211 36.7187 42.7247 36.7187C48.0948 36.7187 52.4482 32.3676 52.4482 27.0001V16.2703H52.4481Z"
                            fill="white"
                        />
                        <path
                            d="M59.7783 14.4769V13.3578C58.4023 13.3599 57.0534 12.9748 55.886 12.2464C56.9194 13.3773 58.2802 14.157 59.7783 14.4769ZM52.5278 7.27995C52.4928 7.07986 52.4659 6.87845 52.4472 6.67627V6H47.1559V27.0006C47.1474 29.4485 45.1597 31.4309 42.7081 31.4309C41.9883 31.4309 41.3088 31.2601 40.7069 30.9567C41.5197 32.0227 42.8031 32.7108 44.2476 32.7108C46.6988 32.7108 48.687 30.7287 48.6956 28.2805V7.27995H52.5278ZM44.0582 18.5643V17.373C43.6161 17.3126 43.1703 17.2822 42.724 17.2825C37.3535 17.2824 33 21.6335 33 27.0006C33 30.3655 34.711 33.331 37.311 35.0754C35.5961 33.3234 34.5396 30.9254 34.5396 28.2804C34.5396 22.9817 38.7823 18.6732 44.0582 18.5643Z"
                            fill="#00F2EA"
                        />
                        <path
                            d="M121.086 32.3163C124.929 32.3163 128.044 29.2264 128.044 25.4152C128.044 21.6041 124.929 18.5137 121.086 18.5137H120.038C123.881 18.5137 126.996 21.604 126.996 25.4152C126.996 29.2264 123.881 32.3163 120.038 32.3163H121.086Z"
                            fill="#FF004F"
                        />
                        <path
                            d="M119.944 18.5137H118.895C115.053 18.5137 111.938 21.604 111.938 25.4152C111.938 29.2264 115.053 32.3163 118.895 32.3163H119.944C116.101 32.3163 112.986 29.2264 112.986 25.4152C112.986 21.6041 116.101 18.5137 119.944 18.5137Z"
                            fill="#00F2EA"
                        />
                        <path
                            d="M67.0525 15.3945V18.8926H71.15V32.2219H75.2491V18.9871H78.5846L79.7282 15.3946H67.0525V15.3945ZM100.601 15.3945V18.8926H104.698V32.2219H108.797V18.9871H112.132L113.276 15.3946H100.601V15.3945ZM80.4914 17.3796C80.4914 16.2835 81.386 15.3945 82.4912 15.3945C83.5974 15.3945 84.493 16.2835 84.493 17.3796C84.493 18.4759 83.598 19.3649 82.4912 19.3649C81.386 19.3643 80.4914 18.4759 80.4914 17.3796ZM80.4914 20.7833H84.493V32.2219H80.4914V20.7833ZM86.2088 15.3945V32.2218H90.212V27.8736L91.4511 26.7382L95.3581 32.3162H99.6466L94.0231 24.1863L99.0744 19.2699H94.214L90.212 23.2402V15.3945H86.2088ZM129.382 15.3945V32.2218H133.386V27.8736L134.624 26.7382L138.532 32.3162H142.821L137.198 24.1863L142.249 19.2699H137.389L133.386 23.2402V15.3945H129.382Z"
                            fill="white"
                        />
                        <path
                            d="M120.039 32.3163C123.881 32.3163 126.997 29.2264 126.997 25.4152C126.997 21.6041 123.881 18.5137 120.039 18.5137H119.944C116.101 18.5137 112.986 21.604 112.986 25.4152C112.986 29.2264 116.101 32.3163 119.944 32.3163H120.039ZM116.608 25.4152C116.608 23.5613 118.123 22.0596 119.992 22.0596C121.86 22.0596 123.375 23.5613 123.375 25.4152C123.375 27.2691 121.86 28.7716 119.992 28.7716C118.123 28.7713 116.608 27.2691 116.608 25.4152Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div
                    className="logo-google"
                    onClick={() => {
                        _handleRenderDialog(SOCIAL.Facebook);
                    }}
                >
                    <span>Facebook</span>
                </div>
            </div>
        </LoginArtistStyle>
    );
}
const LoginArtistStyle = styled.div`
    width: 100%;
    background-color: #313131;
    min-height: 100svh;
    position: relative;

    .logo-verify{
        position: absolute;
        top: 20px;
        left: 20px;
    }



    .login-artist {
        position: absolute;
        top: 165px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 95%;
        width: 327px;
        background: #3a3a3a;
        border-radius: 10px;
        padding: 20px;
        text-align: center;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            text-align: center;
            letter-spacing: -0.3px;
            color: #ffffff;
            margin-bottom: 32px;
        }

        .logo {
            width: 175px;
            height: 46px;
            cursor: pointer;
            margin: 32px auto 10px;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .logo-google > span {
        color: white;
        font-size: 24px;
        height: 46px;
        font-weight: 700;
        line-height: 46px;
    }

    .logo-google {
        background: black;
        width: 175px;
        border-radius: 40px;
        text-align: center;
        margin: 0 auto;
        cursor: pointer;
    }
`;
export default LoginArtist;



// WEBPACK FOOTER //
// ./src/artist-ui/LoginArtist.js